@if (loader.isLoading$ | async) {
  <section class="loader-container">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="50"
    ></mat-progress-spinner>
  </section>
}
